import React from "react";
import { View } from "react-native";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import TextInput from "app/components/TextInput";

// documentation
// https://reactdatepicker.com/

// format options
// https://date-fns.org/v2.17.0/docs/format

export default class DatePickerWeb extends React.Component {
  render() {
    let { dateOnly } = this.props;
    let dateFormat = "E, L/d h:mma";
    let showTimeInput = true;

    if (dateOnly) {
      dateFormat = "E, L/d";
      showTimeInput = false;
    }

    let { inputStyle, placeholder } = this.props;

    return (
      <View
        style={[
          // {width: 350},
          { width: "auto" },
          { zIndex: 4 },
          // styleSheet.input,
          // this.props.inputStyle,
        ]}
      >
        <DatePicker
          // dateFormat="Pp"
          // withPortal
          // dateFormat="E, L/d h:mma"
          // showTimeSelect={true}
          dateFormat={dateFormat}
          showTimeInput={showTimeInput}
          {...this.props}
          customInput={<TextInput style={inputStyle} />}
          popperPlacement="bottom"
          // popperModifiers={{
          //   flip: {
          //     enabled: false,
          //   },
          //   preventOverflow: {
          //     enabled: true,
          //     escapeWithReference: false,
          //   },
          // }}
        />
      </View>
    );
  }
}
